export enum Role {
  USER = 'user',
  STAFF = 'staff',
  ADMIN = 'admin',
  STOCK_MANAGER = 'stock_manager',
}

export const ROLE_LABELS: Record<Role, string> = {
  [Role.USER]: '普通用户',
  [Role.STAFF]: '加工坊员工',
  [Role.ADMIN]: '管理员',
  [Role.STOCK_MANAGER]: '库存管理员',
};

export const ADMIN_ROLES = [Role.ADMIN];
export const STOCK_ROLES = [Role.ADMIN, Role.STOCK_MANAGER];
